import { useQuery } from '@tanstack/react-query';
import {
  getOneBugFeature,
  getUser,
  listBugFeature,
  getBugFeatureStatistics,
  getAuthorizedDomains,
  getSIBDomains,
} from 'services/admin';

export const useGetUser = (id: number) => {
  return useQuery(['getUser', { id }], () => getUser(id), {
    keepPreviousData: true,
    refetchOnMount: 'always',
    initialData: { id },
  });
};

export const useGetOneBugFeature = (id: number) => {
  return useQuery(['getOneBugFeature', { id }], () => getOneBugFeature(id), {
    keepPreviousData: true,
    refetchOnMount: 'always',
    initialData: { id },
  });
};

export const LIST_BUG_FEATURE_QUERY_KEY = 'listBugFeature';

export const useListBugFeature = query => {
  return useQuery(
    [LIST_BUG_FEATURE_QUERY_KEY, { ...query }],
    () => listBugFeature(query),
    {
      keepPreviousData: true,
      refetchOnMount: 'always',
      initialData: [],
    },
  );
};

export const useGetBugFeatureStatistics = () => {
  return useQuery(['getBugFeatureStatistics'], getBugFeatureStatistics, {
    keepPreviousData: true,
    refetchOnMount: 'always',
    initialData: {},
  });
};

export const LIST_AUTHORIZED_DOMAINS_QUERY_KEY = 'listAuthorizedDomains';

export const useGetAuthorizedDomains = () => {
  return useQuery([LIST_AUTHORIZED_DOMAINS_QUERY_KEY], getAuthorizedDomains, {
    keepPreviousData: true,
    refetchOnMount: 'always',
    initialData: [],
  });
};

export const LIST_SIB_DOMAINS_QUERY_KEY = 'listSIBDomains';

export const useGetSIBDomains = () => {
  return useQuery([LIST_SIB_DOMAINS_QUERY_KEY], getSIBDomains, {
    keepPreviousData: true,
    refetchOnMount: 'always',
    initialData: [],
  });
};
